import React from "react";

export const DeviceTypeIconMobile = (): JSX.Element => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" fill="none" />
            <path
                d="M21.5625 33.175C21.5625 34.0375 20.8625 34.7375 20 34.7375C19.1375 34.7375 18.4375 34.0375 18.4375 33.175C18.4375 32.3125 19.1375 31.6125 20 31.6125C20.8625 31.6125 21.5625 32.3125 21.5625 33.175Z"
                fill="url(#paint0_linear_799_6841)"
            />
            <path
                d="M28.0187 1.92505H11.9812C10.7687 1.92505 9.7937 2.9063 9.7937 4.11255V35.8875C9.7937 37.1 10.7687 38.075 11.9812 38.075H28.0187C29.225 38.075 30.2 37.1 30.2062 35.8875V4.11255C30.2062 2.9063 29.225 1.9313 28.0187 1.92505ZM28.3312 35.8875C28.3312 36.0625 28.1875 36.2 28.0187 36.2H11.9812C11.8062 36.2 11.6687 36.0625 11.6687 35.8875V4.11255C11.6687 3.9438 11.8062 3.8063 11.9812 3.80005H28.0187C28.1875 3.8063 28.325 3.9438 28.3312 4.11255V35.8875Z"
                fill="url(#paint1_linear_799_6841)"
            />
            <path
                d="M22.4562 6.46875H17.5437C17.2 6.46875 16.9187 6.1875 16.9187 5.84375C16.9187 5.5 17.2 5.21875 17.5437 5.21875H22.4562C22.8 5.21875 23.0812 5.5 23.0812 5.84375C23.0812 6.1875 22.8 6.46875 22.4562 6.46875Z"
                fill="url(#paint2_linear_799_6841)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_799_6841"
                    x1="40.0875"
                    y1="13.0875"
                    x2="13.0875"
                    y2="40.0875"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3C5EAB" />
                    <stop offset="0.23" stopColor="#3959A2" />
                    <stop offset="0.62" stopColor="#304B8A" />
                    <stop offset="1" stopColor="#253A6B" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_799_6841"
                    x1="33.5"
                    y1="6.50005"
                    x2="6.49996"
                    y2="33.5001"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3C5EAB" />
                    <stop offset="0.23" stopColor="#3959A2" />
                    <stop offset="0.62" stopColor="#304B8A" />
                    <stop offset="1" stopColor="#253A6B" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_799_6841"
                    x1="28.325"
                    y1="-2.48125"
                    x2="1.32495"
                    y2="24.5188"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3C5EAB" />
                    <stop offset="0.23" stopColor="#3959A2" />
                    <stop offset="0.62" stopColor="#304B8A" />
                    <stop offset="1" stopColor="#253A6B" />
                </linearGradient>
            </defs>
        </svg>
    );
};
